import React from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { TPartTabsProps } from './PartTabs.types';

const TabsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
`;

interface TabButtonProps {
  isActive: boolean;
  isFirst: boolean;
  isLast: boolean;
  isOnly: boolean;
}

const TabButton = styled.button<TabButtonProps>`
  padding: 8px 16px;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colorPrimaryDefault : theme.colorWhitePrimary};
  color: ${({ isActive, theme }) =>
    isActive ? theme.colorWhitePrimary : theme.colorBlackDescription};
  cursor: pointer;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border: 1px solid ${({ theme }) => theme.colorBlackMainBorder};
  border-left: ${({ isFirst, theme }) =>
    isFirst ? `1px solid ${theme.colorBlackMainBorder}` : 'none'};
  border-radius: ${({ isFirst, isLast, isOnly }) => {
    if (isOnly) return '8px';
    if (isFirst) return '8px 0 0 8px';
    if (isLast) return '0 8px 8px 0';
    return '0';
  }};
  text-align: center;
`;

const TabText = styled.div`
  display: inline-block;
`;

const PartTabs: React.FC<TPartTabsProps> = ({
  parts,
  activePartIndex,
  onPartChange,
}) => {
  const isOnlyOneTab = parts.length === 1;

  const formatDateOnly = (dateTimeString: string) => {
    if (!dateTimeString) return '';
    return dayjs(dateTimeString).format('MMM DD, YYYY');
  };

  return (
    <TabsContainer>
      {parts.map((part, index) => {
        const isActive = activePartIndex === index;
        const partNumber = 'partNumber' in part ? part.partNumber : index + 1;
        const partDate =
          'date' in part ? part.date : (part as any).date || { value: '' };

        const dateOnly = formatDateOnly(partDate?.value || '');

        const isFirst = index === 0;
        const isLast = index === parts.length - 1;

        const partKey = `part-tab-${partNumber}-${dateOnly.replace(
          /\s+/g,
          '',
        )}`;

        return (
          <TabButton
            key={partKey}
            type="button"
            isActive={isActive}
            isFirst={isFirst}
            isLast={isLast}
            isOnly={isOnlyOneTab}
            onClick={() => onPartChange(index)}
          >
            <TabText
              dangerouslySetInnerHTML={{
                __html: `<strong>Part ${partNumber}</strong> - ${dateOnly}`,
              }}
            />
          </TabButton>
        );
      })}
    </TabsContainer>
  );
};

export default PartTabs;
